import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export function ForcePasswordChange() {
  const { user, refreshUser, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.next.length < 8) { setErr("A nova palavra-passe deve ter pelo menos 8 caracteres"); return; }
    if (f.next !== f.confirm) { setErr("As palavras-passe não coincidem"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Palavra-passe atualizada");
      await refreshUser();
    } catch (ex) { setErr(formatApiErrorDetail(ex.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0D1B2A] p-5" data-testid="force-password-screen">
      <form onSubmit={submit} className="card-almar w-full max-w-md p-8 space-y-4">
        <div className="flex justify-center mb-2"><Logo size="md" /></div>
        <div className="flex items-center gap-2 text-[#C9A84C]"><KeyRound size={18} /><h1 className="font-display text-xl">Definir nova palavra-passe</h1></div>
        <p className="text-sm text-slate-400">Olá {user?.name}. Está a usar uma palavra-passe temporária. Para continuar, escolha uma nova palavra-passe pessoal.</p>
        <input type="password" required className="input-almar" placeholder="Palavra-passe temporária" value={f.current} onChange={set("current")} data-testid="fp-current" />
        <input type="password" required className="input-almar" placeholder="Nova palavra-passe (mín. 8 caracteres)" value={f.next} onChange={set("next")} data-testid="fp-new" />
        <input type="password" required className="input-almar" placeholder="Confirmar nova palavra-passe" value={f.confirm} onChange={set("confirm")} data-testid="fp-confirm" />
        {err && <p className="text-sm text-red-400" data-testid="fp-error">{err}</p>}
        <button type="submit" disabled={busy} data-testid="fp-submit" className="w-full bg-[#C9A84C] hover:bg-[#D9B85C] text-[#0D1B2A] font-semibold rounded-lg py-2.5 disabled:opacity-60">{busy ? "A guardar..." : "Guardar e entrar"}</button>
        <button type="button" onClick={logout} data-testid="fp-logout" className="w-full text-xs text-slate-400 hover:text-slate-200">Sair</button>
      </form>
    </div>
  );
}
